import React, { useState } from "react";
import { DeviceInfo, EditDevice } from "./";
import { ModalComp } from "../";
import { useTranslation } from "react-i18next";

const DeviceSetting = ({ device }) => {
  const [openDeviceInfoModal, setOpenDeviceInfoModal] = useState(false);
  const toggleDeviceInfo = () => setOpenDeviceInfoModal(!openDeviceInfoModal);
  const [openEditModal, setOpenEditModal] = useState(false);
  const toggleEdit = () => setOpenEditModal(!openEditModal);
  const { t } = useTranslation();

  return (
    <>
      <ModalComp
        modal={openEditModal}
        toggle={toggleEdit}
        component={<EditDevice device={device} toggleEdit={toggleEdit} />}
      />
      <ModalComp
        modal={openDeviceInfoModal}
        toggle={toggleDeviceInfo}
        component={
          <DeviceInfo toggleDeviceInfo={toggleDeviceInfo} device={device} />
        }
      />
      <div style={{ minHeight: "80vh" }}>
        <div className="d-flex align-items-center flex-column">
          <i className="circleTop icon-plug text-center"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("تنظیمات دستگاه")}</p>
            <p className="fn12 text-muted">{device.caption}</p>
          </div>
        </div>
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={toggleDeviceInfo}
        >
          <p className="fn">{t("اطلاعات دستگاه")}</p>
        </div>
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={toggleEdit}
        >
          <p className="fn">{t("ویرایش نام دستگاه")}</p>
        </div>
      </div>
    </>
  );
};

export { DeviceSetting };
